import { useState } from 'react';
import { TriangleAlert } from 'lucide-react';

import { Button } from 'src/components/ui/button';
import { useOnboardingStepSubmit } from 'src/context/onboarding-step-submit';

type Props = {
  onSuccess: () => void;
  children: React.ReactNode;
};

export const StepSubmitButton = ({ onSuccess, children }: Props) => {
  const { submitStep, stepError } = useOnboardingStepSubmit();
  // Plain state rather than useTransition: React entangles pending async transitions, so an unrelated slow
  // action elsewhere would hold back the step's error state and keep this button loading
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmitStep = async () => {
    setIsSubmitting(true);

    try {
      if (await submitStep()) onSuccess();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex items-center gap-4">
      {stepError && (
        <p role="alert" className="flex items-center gap-1.5 text-xs text-destructive">
          <TriangleAlert className="size-3.5" />
          {stepError}
        </p>
      )}
      <Button onClick={handleSubmitStep} isLoading={isSubmitting}>
        {children}
      </Button>
    </div>
  );
};
